<template>
  <span class="rounded-2xl size-9 animate-pulse bg-gray-950" />
</template>
